import { CrossFrameUtils } from '@src/utils';

import _ from 'lodash';
import $ from 'jquery';

interface IConfigDataType {
    store: string;
    domainAndRealm: string;
    storeInfo?: any;
    [x: string]: any;
}
export interface IAppInfoType extends IConfigDataType {
    toolName: string;
}

/**
 * A service that encapsulates the logic for making the CrossFrameCall to load Application Configuration Data
 * such as Store information and domain
 *
 * TODO: Remove promise, loadAppInfo, getAppInfo, and move appInfoLoader out of CrossFrameUtils.
 *
 */
export class AppInfoLoader {
    // Default tool name - each tool's config should call setToolName() to override
    public static toolName = 'Unknown';

    public static setToolName(name: string) {
        AppInfoLoader.toolName = name;
    }

    /**
     * @function
     * @description Obtain the app configuration for this device.
     * @param {boolean} shouldReloadAppConfig - (Optional) when set to true, the previously cached
     *        result is reloaded from the device, otherwise, a cached response is returned.
     * @return {Promise} a cached promise that resolves to the app information
     * @resolve {AppConfig}
     * @reject {Exception}
     */
    public static async getAppConfig(shouldReloadAppConfig?: boolean): Promise<IAppInfoType> {
        if (AppInfoLoader._appInfoPromise && !shouldReloadAppConfig) {
            try {
                const appInfo = await AppInfoLoader._appInfoPromise;
                appInfo.toolName = AppInfoLoader.toolName;
                return appInfo;
            } catch (error) {
                console.error(error);
            }
        }
        try {
            const configData: IConfigDataType = await CrossFrameUtils.sendMessageToOtherFrame({
                frame: window,
                message: {
                    method: 'loadAppInfo',
                    data: {},
                },
            });
            let store = configData.store || '';
            let domainAndRealm = configData.domainAndRealm || '';
            store = store.trim();
            domainAndRealm = domainAndRealm.trim();
            // TODO:: Eventually, loadAppInfo should reject with an appropriate message
            if (domainAndRealm.length === 0 || store.length === 0) {
                return Promise.reject({ message: 'Could not load appInfo' });
            }
            AppInfoLoader._appInfo = _.extend(configData, { toolName: AppInfoLoader.toolName });
            console.debug('Binding Coral to domain: %s', domainAndRealm);
            AppInfoLoader._appInfoPromise = Promise.resolve(AppInfoLoader._appInfo);
            return AppInfoLoader._appInfo;
        } catch (error) {
            console.error(error);
            return Promise.reject(`Error occured: ${error}`);
        }
    }

    private static _appInfoPromise = undefined;
    private static _appInfo = undefined;
}
